import { css } from '@/styled-system/css';

export const headerWrapperStyles = css.raw({
  width: '100%',
  marginBottom: 'loose',
  marginTop: {
    base: 'loose',
    xl: 'looser',
  },
  paddingInline: {
    base: 'default',
    xl: '0',
  },
});

export const zillowHeaderWrapperStyles = css.raw({
  flexDirection: {
    lgDown: 'column',
    lg: 'row',
  },
  alignItems: {
    lgDown: 'flex-start',
    lg: 'center',
  },
});

export const zillowFolderSelectorStyles = css.raw({
  marginLeft: {
    lgDown: 0,
    lg: 'auto',
  },
  marginTop: {
    lgDown: 'loose',
    lg: 0,
  },
});
